import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { useState,  useEffect } from 'react';

import HandleSentence from './HandleSentence';



const renderData = (data, indexOfFirstItem, indexOfLastItem, query, domain, trans) => {
  let ordinal = []
  

  for (let i = indexOfFirstItem + 1; i <= indexOfLastItem + 1; i++) {
      ordinal.push(i)
  }

  return(
    <ul> {
      data.map((item, index) => ( <li style = {{ textAlign: 'left', listStyle: "none" }}
        key = {index}> <b>{ordinal[index]}.</b>  <HandleSentence sentence={item} query={query} domain={domain} trans={trans}/> </li>
      ))
  }

  </ul>
  )
};


export default function PaginationControlled({queryResult, query, domain, trans}) {


  const [page, setPage] = useState(1);
  const [data, setData] = useState(queryResult);
  const [itemsPerPage, ] = useState(15);
  const [content, setContent] = useState(false);

  let indexOfLastItem = page*itemsPerPage;
  let indexOfFirstItem = indexOfLastItem - itemsPerPage;
  let currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  let NumberOfPages = Math.ceil(data.length/itemsPerPage);
  
  

  useEffect(() => {

    setData(queryResult)

}, [queryResult])



  useEffect(() => {

    setContent(renderData(data.slice(0, 15), 0, 15, query, domain, trans))

}, [data, query, domain, trans])



  const handleChange = (event, value) => {
    setPage(value);

    indexOfLastItem = value*itemsPerPage;
    indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
    NumberOfPages = Math.ceil(data.length/itemsPerPage)
    setContent(renderData(currentItems, indexOfFirstItem, indexOfLastItem, query, domain))

  };



  return (
    <Stack spacing={2}>
      {content ? content : null}
      {query?  <Pagination count={NumberOfPages} page={page} onChange={handleChange} /> : null}
    </Stack>
  )
}


// 